import { render, staticRenderFns } from "./agreement_manager.vue?vue&type=template&id=6a7405e8&scoped=true&"
import script from "./agreement_manager.vue?vue&type=script&lang=js&"
export * from "./agreement_manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7405e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a7405e8')) {
      api.createRecord('6a7405e8', component.options)
    } else {
      api.reload('6a7405e8', component.options)
    }
    module.hot.accept("./agreement_manager.vue?vue&type=template&id=6a7405e8&scoped=true&", function () {
      api.rerender('6a7405e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/agreements/agreement_manager.vue"
export default component.exports